import React from "react";

const PricingSection = () => {
  return (
    <section id="pricing" className="pricing-section">
      <div className="pricing-header">
        <h2 className="pricing-title">Pricing Plans</h2>
        <p className="pricing-subtitle">
          Select the plan that works best for your business. Affordable and scalable for teams of all sizes.
        </p>
      </div>

      <div className="pricing-cards">
        {/* Starter Plan */}
        <div className="pricing-card">
          <div className="card-header">
            <h3 className="card-title">Starter</h3>
            <p className="card-price">$99 <span>/month</span></p>
          </div>
          <p className="card-description">Best for small teams and startups.</p>
          <ul className="card-features">
            <li>Payroll for up to 20 employees</li>
            <li>Single-country payroll</li>
            <li>Email support</li>
            <li>compliance tools</li>
            <li>Limited Employees and countries</li>
          </ul>
          <button className="card-button">Get Started</button>
        </div>

        {/* Growth Plan */}
        <div className="pricing-card highlighted-card">
          <div className="card-header">
            <h3 className="card-title">Growth</h3>
            <p className="card-price">$249 <span>/month</span></p>
          </div>
          <p className="card-description">For growing businesses with global teams.</p>
          <ul className="card-features">
            <li>Payroll for up to 100 employees</li>
            <li>Multi-country payroll</li>
            <li>Advanced compliance tools</li>
            <li>Priority support</li>
          </ul>
          <button className="card-button highlighted-button">Upgrade Now</button>
        </div>

        {/* Enterprise Plan */}
        <div className="pricing-card">
          <div className="card-header">
            <h3 className="card-title">Enterprise</h3>
            <p className="card-price">Custom Pricing</p>
          </div>
          <p className="card-description">Tailored for enterprises with complex needs.</p>
          <ul className="card-features">
            <li>Unlimited employees and countries</li>
            <li>Custom integrations</li>
            <li>Dedicated account manager</li>
            <li>24/7 premium support</li>
          </ul>
          <button className="card-button">Contact Us</button>
        </div>
      </div>
    </section>
  );
};

export default PricingSection;
